export default "__VITE_ASSET__loetUgx4__"